import React from 'react'
import PropTypes from 'prop-types'
import { Logo } from '../Logo'
import { Links } from './Links'
import { themes } from 'common/constants/CampaignEditorConfig'
import { default_tracking_config as trackingConfigDefaultValues } from 'common/constants/CampaignEditorConfig'
import { ConfirmationDialog, CONFIRMATION_TYPES } from 'shared/UI/ConfirmationDialog'
import get from 'lodash/get'
import { triggerClickOnEnter, ACCESSIBILITY_CLASSES, TAB_INDEXES } from 'shared/helpers/AccessibilityHelper'

import './style.css.scss'

const TEXT_COLOR_TYPE = {
  theme: 0,
  custom: 1
}

const TRACK_BUTTON_CLICKED_INDICATION_TEXT = 'Confirmed - your tracking is disabled'

const CustomFooter = (props) => {
  const trackingConsentConfig = props.config.tracking_consent
  const showTrackButton = get(
    trackingConsentConfig,
    'show',
    trackingConfigDefaultValues.show
  )
  const trackButtonLabel = get(
    trackingConsentConfig,
    'button_label',
    trackingConfigDefaultValues.button_label
  )

  const { background_color, text_color } = props.config
  const themeConfig = themes[background_color]
  const backgroundColor = themeConfig ? themeConfig.hex : background_color
  const textColor =
    text_color.type == TEXT_COLOR_TYPE.theme ? props.themeColorHex : text_color.color
  const trackButtonEnabledClassName = props.trackButtonEnabled ? '' : 'disabled'
  const showTrackButtonClassName = showTrackButton ? 'footer-content-right-section' : ''

  return (
    <>
      { !!props.showTrackInfoDialog &&
        <ConfirmationDialog
          themeColor={props.themeColorHex}
          onCustomButton={props.closeTrackInfoDialog}
          customButtonLabel={'Close'}
          customButtonStyle={{ backgroundColor: props.themeColorHex }}
          confirmationType={CONFIRMATION_TYPES.info}
          header={trackingConsentConfig.dialog_button_label}
          title={trackingConsentConfig.dialog_text}
          dialogClassName='tracking-info-dialog'
          showCloseButton={false}
          closeOnConfirm={false} />
      }
      <div className="custom-footer-wrapper" style={{ backgroundColor: backgroundColor }}>
        <div className={`footer-content ${showTrackButtonClassName}`} style={{color: textColor}}>
          { !!showTrackButton &&
            <div className="tracking-consent-container">
              <div
                style={{color: props.textColor, borderColor: props.textColor}}
                className={`tracking-consent-button ${trackButtonEnabledClassName} ${ACCESSIBILITY_CLASSES.main}`}
                onClick={props.onTrackClick}
                onKeyDown={triggerClickOnEnter}
                tabIndex={TAB_INDEXES.CustomFooterTrackButton}
                role="button">
                {trackButtonLabel}
              </div>
              <div
                style={{color: props.textColor}}
                className={`track-info-button ${ACCESSIBILITY_CLASSES.main}`}
                onClick={props.openTrackInfoDialog}
                onKeyDown={triggerClickOnEnter}
                tabIndex={TAB_INDEXES.CustomFooterTrackButton}
                role="button">
                {trackingConsentConfig.dialog_button_label}
              </div>
              { props.showTrackButtonClickedIndication &&
                <span className="button-clicked-label">
                  {TRACK_BUTTON_CLICKED_INDICATION_TEXT}
                </span>
              }
            </div>
          }
          <div className="center-container">
            { get(props.config.logo, 'show') && get(props.config.logo, 'image.url') &&
              <Logo image={get(props.config, 'logo')} />
            }
            <Links data={get(props.config, 'labels')} themeColorHex={textColor} />
            { props.config.text && <p>{props.config.text}</p> }
          </div>
        </div>
      </div>
    </>
  )
}

CustomFooter.propTypes = {
  config: PropTypes.object,
  themeColorHex: PropTypes.string,
  showTrackButtonClickedIndication: PropTypes.bool,
  trackButtonEnabled: PropTypes.bool,
  onTrackClick: PropTypes.func,
}

export default CustomFooter
